var terms = document.getElementById('cartTermsConfirmation');
var termsCheckbox = document.getElementById('CartTermsDrawer');
if (terms) {
  function termsClose() {
    setTimeout(function() {
      document.body.classList.remove('terms-confirmation--open');
    }, 20);
  }

  function termsAccept() {
    setTimeout(function() {
      document.body.classList.remove('terms-confirmation--open');
    }, 20);

    termsCheckbox.checked = true;

    if (termsCheckbox.checked) {
      document.querySelector('#CartDrawerForm button[type="submit"]').click();
    }
  }

  var closeTermsElems = document.querySelectorAll('[data-terms-confirmation-action*="decline"]');
  if (closeTermsElems) {
    closeTermsElems.forEach((closeTermsElem) => {
      closeTermsElem.addEventListener('click', (e) => {
        e.stopPropagation();

        window.sessionStorage.setItem('validatedProductLimits', 'false');
        termsClose();
      })
    });
  }


  var acceptTermsElems = document.querySelectorAll('[data-terms-confirmation-action*="accept"]');
  if (acceptTermsElems) {
    acceptTermsElems.forEach((acceptTermsElem) => {
      acceptTermsElem.addEventListener('click', (e) => {
        e.stopPropagation();

        termsAccept();
      })
    });
  }

}


/* init size guide drawer */
new theme.Drawers('SizeGuide', 'size-guide');


/* tab */
let activeTab;
let index = 0;

class Tab {

  constructor(tab, content) {
    if (!tab || !content) {
      console.warn(`Tab class failing, tab: ${ tab }, content: ${ content }`);
      return;
    }

    this.dom = {
      trigger: tab,
      content: content
    }

    this.index = index;

    if (this.index === 0) {
      activeTab = this
      this.dom.trigger.classList.add('open');
      this.dom.content.classList.add('open');
    }

    index++;


    var _this = this;

    this.dom.trigger.addEventListener('click', function() {

      if (activeTab && _this.index !== activeTab.index) {
        // Dobbelt check added to prevent delayed dobbelt opening
        if (activeTab.dom.content.classList.contains('open')) {

          _this.toggleElem({ elem: activeTab.dom.trigger })
          _this.toggleElem({ elem: activeTab.dom.content })


          activeTab.dom.trigger.setAttribute('aria-expanded', 'false');
          activeTab.dom.content.setAttribute('aria-hidden', true);

          _this.toggleElem({ elem: _this.dom.trigger })
          _this.toggleElem({ elem: _this.dom.content })
        }
      } else if (activeTab && _this.index === activeTab.index) {
        return;
      }

      _this.dom.content.setAttribute('aria-hidden', false);
      // Set the inverted value of aria-expanded

      var ariaExpanded = _this.dom.trigger.getAttribute('aria-expanded') || 'false';
      _this.dom.trigger.setAttribute('aria-expanded', ariaExpanded === 'false');

      activeTab = _this;

    });
  }

  toggleElem({ elem }) {

    if (elem.classList.contains('open')) {
      elem.classList.remove('open');
    } else {
      elem.classList.add('open');
    }
  }

}

var tabGroups = document.querySelectorAll('.js-tab-group');

tabGroups.forEach((tabGroup) => {
  var tabs = tabGroup.querySelectorAll('.js-tab');
  var tabsContent = tabGroup.querySelectorAll('.js-tab-content');

  tabs.forEach((tabElem, i) => {
    new Tab(tabElem, tabsContent[i]);
  });
});


/**
 * Custom slider - flickity
 */

document.addEventListener('recommendations:loaded', function() {

  var productRecommendations = document.querySelectorAll('[data-slider][data-section-type="product-recommendations"]')
  productRecommendations.forEach((productRecommendation) => {
    var container = productRecommendation.querySelector('.grid');
    var prev = productRecommendation.querySelector('.btn-prev');
    var next = productRecommendation.querySelector('.btn-next');

    var options = {
      draggable: '>1',
      wrapAround: false,
      pageDots: false,
      prevNextButtons: false,
      cellAlign: 'left',
      contain: true
    }

    var recommendedSlider = new Flickity(container, options);

    prev.addEventListener('click', function() {
      recommendedSlider.previous()
    })
    next.addEventListener('click', function() {
      recommendedSlider.next()
    })

  });

})


/**
 * Cart upsell
 */

if (upsellTriggers2.length) {
  function disableUpsellProducts() {
    if (allUpsells) {
      allUpsells.forEach(i => {
        i.forEach(v => {
          var upsellItem = document.querySelectorAll(`.cart__item[data-id="${ v.product_id }"]`);
          if (upsellItem.length) {
            upsellItem.forEach(item => {
              var itemMinus = item.querySelector('.js-qty__adjust--minus')
              var itemPlus = item.querySelector('.js-qty__adjust--plus')

              if (itemMinus) itemMinus.classList.add('hide')
              if (itemPlus) itemPlus.classList.add('hide')
            })
          }
        })
      })
    }
  }

  function getTrigger(id) {
    return upsellTriggers2.find(i => i.product_trigger.id === id)
  }

  const serializeForm = form => {
    const obj = {};
    const formData = new FormData(form);
    for (const key of formData.keys()) {
      if (key !== "form_type" && key !== "utf8") obj[key] = formData.get(key);
    }
    return obj;
  };

  function getUpsellProduct(trigger, variant) {
    let ID
    var currentProductSize = +(variant.variant_title ? variant.variant_title : variant.title);

    if (trigger.product_trigger.break && trigger.to_add.length > 1 && currentProductSize) {
      if (currentProductSize <= trigger.product_trigger.break) {
        if (trigger.product_trigger.variant_one) {
          var variantSearch = trigger.to_add.find(i => i.title.toLowerCase() === trigger.product_trigger.variant_one.toLowerCase())
          if (variantSearch) ID = variantSearch.id
          else ID = trigger.to_add[0].id
        } else ID = trigger.to_add[0].id
      } else if (currentProductSize > trigger.product_trigger.break) {
        if (trigger.product_trigger.variant_two) {
          var variantSearch = trigger.to_add.find(i => i.title.toLowerCase() === trigger.product_trigger.variant_two.toLowerCase())
          if (variantSearch) ID = variantSearch.id
          else ID = trigger.to_add[0].id
        } else ID = trigger.to_add[1].id
      }
    } else ID = trigger.to_add[0].id

    return ID
  }

  window.addEventListener('load', function() {
    if (location.href.includes('/products/')) {
      const productSection = document.querySelector('.product-section[data-product-id]');
      if (productSection) {
        const productID = +productSection.dataset.productId
        const trigger = getTrigger(productID)
        if (trigger) { // Product has upsell
          const variantJSON = JSON.parse(document.querySelector('[data-variant-json]').innerHTML)
          const addToCartBtn = document.querySelector('button[type="submit"].add-to-cart');
          const form = document.querySelector('form[action="/cart/add"]');
          let formData = { items: [] }

          addToCartBtn.addEventListener('click', (evt) => {
            evt.preventDefault();
            addToCartBtn.classList.add('btn--loading');

            const defaultFormData = serializeForm(form)
            const selectedVariant = variantJSON.find(i => i.id === +defaultFormData.id);

            if (!defaultFormData.quantity) {
              defaultFormData.quantity = 1;
            }

            formData.items.push(defaultFormData);

            const upsellProduct = getUpsellProduct(trigger, selectedVariant)
            if (upsellProduct) {
              formData.items.push({ id: upsellProduct.toString(), quantity: defaultFormData.quantity });
            }

            theme.cart.addToCart(formData, function(product) {
              theme.cart.getCart().then(cart => {
                theme.settings.cart = cart
                formData = { items: [] }
                document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                  detail: {
                    product: product,
                    addToCartBtn: addToCartBtn
                  }
                }));
              })

              addToCartBtn.classList.remove('btn--loading')
            })
          })
        }
      }
    }

    disableUpsellProducts()
  })

  document.addEventListener('cart:updated', function(evt) {
    disableUpsellProducts()
  })
}